import CurrentUserProvider from "@/providers/CurrentUserProvider"
import React from "react"
import AdminCalendar from "./Calendar"

const AdminCalendarPage = ({ calendarData }) => {
  return (
    <CurrentUserProvider>
      <AdminCalendar calendarData={calendarData} />
    </CurrentUserProvider>
  )
}

export default AdminCalendarPage
